import React from 'react';
import '@fontsource/poppins';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Styles/style.css'
import './Styles/responsive.css'
// import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainIndex from './Components/MainIndex';

function App() {
  // const haloRef = React.useRef();
  // const sectionRef = React.useRef();

  // const handleMouseMove = (e) => {
  //   const rect = sectionRef.current.getBoundingClientRect();
  //   haloRef.current.style.left = `${e.clientX - rect.left}px`;
  //   haloRef.current.style.top = `${e.clientY - rect.top}px`;
  // };

  return (
    <MainIndex />
    //   <section
    //   className="mesh-test"
    //   ref={sectionRef}
    //   onMouseMove={handleMouseMove}
    //   style={{ position: 'relative', overflow: 'hidden' }}
    // >
    // <BrowserRouter>
    //   <Routes>
    //     <Route path="/" element={<MainIndex />} />
    //   </Routes>
    // </BrowserRouter>
    //   <div ref={haloRef} className="cursor-gradient" />
    // </section>
  );
}

export default App;
